import {useState} from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const genSimpleEmbed = (campaignId) => {
	const APP_ORIGIN = process.env.REACT_APP_APP_URL;
	return `<iframe frameborder='0' style='border-style: none;width: 100%; height: 600px' src='${APP_ORIGIN}/${campaignId}'></iframe>`;
}
const genResizingEmbed = (campaignId) => {
	const __APP_ORIGIN__ = process.env.REACT_APP_APP_URL;
	const __IFRAME_ID__ = "sportovivo-embed-" + Date.now();
	return `
		<iframe id="${__IFRAME_ID__}" frameborder="0" style="border-style: none; width: 100%; height: 100px;" src="${__APP_ORIGIN__}/${campaignId}"></iframe>
		\n\n
		<script>(function(){var n="sportovivo-embed-campaign";var i="${__APP_ORIGIN__}";var e="${__IFRAME_ID__}";var r=document.getElementById(e);if(!r)return;var o=null;function u(e){return e.source===r.contentWindow}function a(){requestAnimationFrame(function(){requestAnimationFrame(function(){var e=r.getBoundingClientRect();if(e.top>=0&&e.top<document.documentElement.clientHeight){return}r.scrollIntoView({behavior:"auto",block:"start"})})})}window.addEventListener("message",function(e){if(e.origin!==i)return;var t=e.data;if(!t||t.source!==n)return;if(!u(e))return;if(t.type==="ready"){o=e.origin;r.contentWindow.postMessage({source:n,type:"init"},o);return}if(t.type==="sportovivo-height"&&typeof t.height==="number"){r.style.height=t.height+"px";return}if(t.type==="sportovivo-page-changed"){a()}})})();</script>
	`.replace(/\n\s+/g, "\n").trim();
}

function EmbedModal({closeCb, campaign_url, custom_user_url}) {
	const code = genSimpleEmbed(campaign_url);
	const resizingCode = genResizingEmbed(campaign_url);

	const [embedType, setEmbedType] = useState('standard');
	const [copiedHtml, setCopiedHtml] = useState(false);
	const [copiedCustomUser, setCopiedCustomUser] = useState(false);

	const copy = (cb) => {
		cb(true);
		setTimeout(() => cb(false), 3000);
	}
	const getCss = (val) => {
		let s = "code__card";
		if(val) s += ' code__card-copied';
		return s;
	}
	const selectEmbedType = (type) => {
		setEmbedType(type);
		setCopiedHtml(false);
	};

	const selectedCode = embedType === 'standard'?code:resizingCode;

	return (
		<div className="modal-overlay active">
			<div className="modal active animate__animated animate__slideInRight">
				<div className="modal__header">
					<div className="modal__header-title">
					</div>
					<div className="close-modal modal--x" onClick={ () => { closeCb(false) }}>
						<svg viewBox="0 0 20 20">
							<path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
						</svg>
					</div>
				</div>
				<div className="modal-content">
					<div className="modal__body">

						{custom_user_url && (
							<div>
								<h4>Native App</h4>

								<div className={getCss(copiedCustomUser)}>
									{!copiedCustomUser && (
										<CopyToClipboard text={custom_user_url} onCopy={() => copy(setCopiedCustomUser)}>
											<div>
												{custom_user_url}

												<button className="btn btn-primary-soft btn-sm code__card-copy">
													<span className="material-icons font--20">
														content_copy
													</span>
												</button>
											</div>
										</CopyToClipboard>
									)}

									{copiedCustomUser && (
										<div className="text--center">
											<span className="material-icons font--30 text--success">
												verified
											</span>
											<br />
											Copied
										</div>
									)}
								</div>
							</div>
						)}

						<h4>Copy this piece of code and add into your page.</h4>

						{/* Embed type tabs */}
						<div className="embed-tabs mtop--15">
							<button
								type="button"
								className={`embed-tabs__tab ${embedType === 'standard'?'embed-tabs__tab--active': ''}`}
								onClick={() => selectEmbedType('standard')}
							>
								Standard
							</button>

							<button
								type="button"
								className={`embed-tabs__tab ${
									embedType === 'resizing'
										? 'embed-tabs__tab--active'
										: ''
								}`}
								onClick={() => selectEmbedType('resizing')}
							>
								Auto-resizing
							</button>
						</div>

						{/* Description */}
						<div className="mtop--15">
							{embedType === 'standard' ? (
								<p className="text--muted">
									Simple iframe with a fixed height.
								</p>
							) : (
								<p className="text--muted">
									Automatically adjusts the iframe height to match
									its content. Requires JavaScript on the host page.
								</p>
							)}
						</div>

						{/* Selected embed code */}
						<div className="mtop--15">
							<label>
								{embedType === 'standard'?'HTML':'HTML + JavaScript'}
							</label>

							<div className={getCss(copiedHtml)}>
								{!copiedHtml && (
									<>
										<CopyToClipboard text={selectedCode} onCopy={() => copy(setCopiedHtml)}>
											<button className="btn btn-primary-soft btn-sm code__card-copy">
												<span className="material-icons font--20">
													content_copy
												</span>
											</button>
										</CopyToClipboard>

										<SyntaxHighlighter
											wrapLongLines={embedType==="standard"}
											language="html"
											style={docco}
											className="syntax-highlight"
										>
											{selectedCode}
										</SyntaxHighlighter>
									</>
								)}

								{copiedHtml && (
									<div className="text--center">
										<span className="material-icons font--30 text--success">
											verified
										</span>
										<br />
										Copied
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="modal__footer text--right">
						<button className="btn btn-primary" onClick={() => closeCb(false)}>
							Done
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default EmbedModal;
